<template>
  <div>
    <el-dialog class='userMsgbox' title="注册" :before-close="handleClose" :close-on-click-modal="false" top='50px'
      width="776px" :visible.sync="showRegister" :append-to-body="true">
      <div class="dialogCenter">
        <el-form class='SDAU_form' ref="form" :model="formData" :rules='rules'>
          <el-row>
            <el-col style='padding-right:30px' :span="11">
              <el-form-item label="学号" prop="studentNo">
                <el-input v-model="formData.studentNo" placeholder="请输入学号"></el-input>
              </el-form-item>
              <!-- placeholder="最小12位需包含数字以及英文大小写" -->
              <el-form-item label="密码" prop="registerPwd">
                <el-input type="password" v-model="formData.registerPwd" placeholder="请输入密码不能小于六位"
                  show-password></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="登录账号" prop="userName">
                <el-input v-model="formData.userName" placeholder="请输入登录账号"></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="againpassword">
                <el-input type="password" v-model="formData.againpassword" placeholder="请确认密码" show-password></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="10" style='padding-right:30px'>
              <el-form-item label="姓名" prop='nickName'>
                <el-input v-model="formData.nickName" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="性别" prop='sex'>
                <el-select v-model="formData.sex" placeholder="请选择性别">
                  <el-option label="男" value="0"></el-option>
                  <el-option label="女" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="email" prop="email">
                <el-input v-model="formData.email" placeholder="请输入邮箱"></el-input>
              </el-form-item>
              <el-form-item label="通讯地址" prop="address">
                <el-input v-model="formData.address" placeholder="请输入通讯地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='14'>
              <el-form-item label="联系电话" prop="phonenumber">
                <el-input v-model="formData.phonenumber" placeholder="请输入联系电话"></el-input>
              </el-form-item>
              <el-form-item label="身份证号" prop="idCard">
                <el-input v-model="formData.idCard" placeholder="请输入身份证号"></el-input>
              </el-form-item>
              <el-form-item label="课题组" prop='projectTeamIdList'>
                <el-select placeholder="请选择课题组" v-model="formData.projectTeamIdList">
                  <el-option v-for="(item, index) in classData" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="机构名称" prop='dept'>
                <el-select class="main-select-tree" ref="selectTree" v-model="formData.deptName">
                  <el-option v-for="(item, index) in deptData" :key="item.id" :label="index + item.label" :value="item.id"
                    style="display: none;" />
                  <el-tree class="main-select-el-tree" ref="selecteltree" :data="deptData" node-key="id" highlight-current
                    :props="defaultProps" @node-click="handleNodeClick" :current-node-key="id"
                    :expand-on-click-node="expandOnClickNode" default-expand-all />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div>
          <el-radio-group :disabled="true" v-model="checked">
            <el-radio label="1" shape="circle">
              <span style="font-size:12px">我已阅读并同意植保学院仪器共享平台</span>
            </el-radio>
            <span style='color:RGB(0,129,255); font-size:12px;margin-left: -30px;cursor: pointer;'
              @click.stop="showprotocol">《用户注册协议》</span>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detail_save">保存</el-button>
        <el-button @click="$emit('close')">返回</el-button>
      </span>
    </el-dialog>
    <proc v-if="showproc" :showproc="showproc" @close="showproc = false" @getValue="getValue" :checked="checked"></proc>
  </div>
</template>
<script>
import proc from './proc.vue'
const { APIURl } = require('@/utils/apiUrl')
export default {
  props: {
    showRegister: {
      default: false
    },
  },
  components: {
    proc
  },
  data() {
    return {
      formData: {
        deptName: '',
        deptId: ''

      },
      id: '',
      checked: '',
      rules: {
        nickName: [
          { required: true, message: '请输入姓名', trigger: ["blur", 'change'] },
        ],
        deptName: [
          { required: true, message: '请选择机构', trigger: ["blur", 'change'] },
        ],
        projectTeamIdList: [
          { required: true, message: '请选择课题组', trigger: ["blur", 'change'] },
        ],
        address: [
          { required: false, message: '校外用户需输入通讯地址', trigger: ["blur", 'change'] },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: ["blur", 'change'] },
          {
            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,    //正则校验不用字符串
            message: "请填写正确的邮箱", trigger: "blur"
          }
        ],
        phonenumber: [
          { required: true, message: '请输入手机号码', trigger: ["blur", 'change'] },
          {
            pattern: /^.{11}$/,    //正则校验不用字符串
            message: "手机号码格式有误", trigger: "blur"
          }
        ],
        idCard: [
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,    //正则校验不用字符串
            message: "请填写正确的身份证号", trigger: "blur"
          }
        ],
        studentNo: [
          { required: true, message: '请输入学号', trigger: ["blur", 'change'] },
        ],
        userName: [
          { required: true, message: '请输入登录账号', trigger: ["blur", 'change'] },
        ],
        registerPwd: [
          { required: true, message: '请输入密码', trigger: ["blur", 'change'] },
          {
            pattern: /^.{6,}$/,    //正则校验不用字符串
            message: "密码不能小于六位", trigger: "blur"
          }
        ],
        againpassword: [
          { required: true, message: '请确认密码', trigger: ["blur", 'change'] },

          {
            pattern: /^.{6,}$/,    //正则校验不用字符串
            message: "密码不能小于六位", trigger: "blur"
          }
        ],
      },
      action: APIURl + '/sdau/app/register/avatar',
      avatar: '',
      deptData: [],
      classData: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'id',

      },
      expandOnClickNode: true,
      showproc: false,
    }
    // {
    //   pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{12,16}$/,    //正则校验不用字符串
    //   message: "密码为12到16位且需包含大小写子母与数字", trigger: "blur"
    // }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },

    init() {
      this.$net('/sdau/app/register/selectProjectTeam', 'get').then(res => {
        this.classData = res.data
      })
      this.$net('/sdau/app/register/selectDept', 'get').then(res => {
        this.deptData = res.data
      })
    },
    detail_save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formData.registerPwd != this.formData.againpassword) {
            this.$message({
              type: "warning",
              message: "两次输入密码不一致"
            })
            return
          }
          if (this.checked != "1") {
            this.$message({
              type: "warning",
              message: "请阅读并确认协议"
            })
            return
          }

          this.formData.projectTeamIdList = [this.formData.projectTeamIdList]
          this.$net('/sdau/app/register', 'post', this.formData).then(res => {
            this.$message({
              type: "success",
              message: " 您已成功提交注册信息，请耐心等待，导师或管理员审核注册信息无误后，您的登录账号会被激活，届时可正常登录使用。",
              duration: 4000
            })
            this.handleClose()
          })
        }
      })
    },
    // onRadioChange(e) {
    //   if (e.target.tagName === "INPUT") {
    //     if (this.checked === "") {
    //       this.checked = "1";
    //     } else {
    //       this.checked = "";
    //     }
    //   }
    // },
    showprotocol() {
      this.showproc = true

    },
    getValue(status) {
      this.checked = status == '1' ? '' : '1'
    },
    handleAvatarSuccess(res) {
      this.avatar = APIURl + '/' + res.imgUrl
      this.formData.avatar = res.imgUrl
    },
    handleNodeClick(node) {
      this.formData.deptName = node.children ? null : node.label;
      this.formData.deptId = node.children ? null : node.id;
      node.children ? null : this.$refs.selectTree.blur();
      this.rules.address[0].required = this.formData.deptName == '校外用户' ? true : false
      this.$refs['form'].clearValidate(['address'])
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep.SDAU_form {
  .el-form-item__label {
    height: 32px;
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    line-height: 32px;
    color: #333333;
    padding-bottom: 8px;
  }

  .el-form-item__content {
    width: 100%;
    height: 72px;

    .el-select {
      width: 100%;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin: 36px 0 0 -76px;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}

.el-select-dropdown__item {
  width: 100%;
}
</style>


